export default "__VITE_ASSET__ee4fcbff__"